import React, { useEffect, useState } from 'react';
import DefaultLayout from 'public/components/DefaultLayout';
import { useParams } from 'react-router-dom';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Spinner } from 'ui';
import FarmView from './FarmView';
import { useFilterDispatch } from 'public/context/FilterContext';
import { FarmGlobalStyle } from './style';
import useMarketType from '../../../utils/useMarketType';

const FarmPage = () => {
  const { id } = useParams<{ slug: string; id: string }>();
  const dispatchFilter = useFilterDispatch();
  const { marketType } = useMarketType();

  const [farmProductPage, setFarmProductPage] = useState(1);
  const [farmProductsData, setFarmProductsData] = useState();

  const { isLoading: isLoadingFarmProducts, appendData } = useQueryApiClient({
    request: {
      url: `api/v2/farms/${id}/products`,
      data: {
        page: farmProductPage,
        marketType: marketType,
      },
      disableOnMount: true,
    },
    onSuccess: (response) => {
      setFarmProductsData(response);
    },
  });

  useEffect(() => {
    appendData({
      page: farmProductPage,
      marketType: marketType,
    });
  }, [farmProductPage]);

  const { isLoading: isLoadingFarm, data: farmData } = useQueryApiClient({
    request: {
      url: `api/v2/farms/${id}`,
      data: {
        marketType: marketType,
      },
    },
  });

  useEffect(() => {
    dispatchFilter({
      type: 'SAVE_PAYLOAD',
      payload: { isFilter: false, openCloseDrawer: () => null },
    });
  }, [dispatchFilter]);

  return (
    <DefaultLayout.PageLayout>
      <DefaultLayout.PageContent>
        <FarmGlobalStyle />
        <Spinner spinning={isLoadingFarm || isLoadingFarmProducts}>
          <FarmView
            farm={farmData}
            farmProducts={farmProductsData}
            onFarmProductsPageChange={(page) => {
              setFarmProductPage(page);
            }}
          />
        </Spinner>
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};

export default FarmPage;
